import { useContext } from 'react'
import { EventContext } from '../components'

export const useEvent = () => useContext(EventContext)

export function formatEventDates(startTime?: number, endTime?: number) {
  const startYear = new Date(startTime!).getFullYear()
  const endYear = new Date(endTime!).getFullYear()

  const optionsShort: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' }
  const optionsFull: Intl.DateTimeFormatOptions = { ...optionsShort, year: 'numeric' }

  const formatDate = (date: number, options: Intl.DateTimeFormatOptions) =>
    new Date(date).toLocaleString('en-US', options)

  if (startTime && endTime) {
    const startFormatted = formatDate(startTime, optionsShort)
    const endFormatted = formatDate(endTime, optionsFull)

    if (startYear === endYear) {
      return `${startFormatted} - ${endFormatted}`
    } else {
      const startFullFormatted = formatDate(startTime, optionsFull)
      return `${startFullFormatted} - ${endFormatted}`
    }
  } else if (startTime) {
    return formatDate(startTime, optionsFull)
  } else if (endTime) {
    return formatDate(endTime, optionsFull)
  }
  return ' '
}

export function eventIsCurrent(startTime: number, endTime?: number) {
  const now = Date.now()
  const allowedStartTime = startTime - 2 * 1000 * 60 * 60 * 24
  const allowedEndTime = endTime ? endTime + 2 * 1000 * 60 * 60 * 24 : null
  return now >= allowedStartTime && (allowedEndTime ? now <= allowedEndTime : true)
}
